<template>
  <div
    class="power-cmd-status"
    :class="{ dark }"
    dir="rtl"
  >
    <!-- وضعیتِ رله از آخرین بستهٔ وضعیتِ دستگاه -->
    <div
      v-if="showRelay && relay.known"
      class="pcs-relay"
      :class="relay.cut ? 'cut' : 'on'"
    >
      <span>رله: <b>{{ relay.cut ? 'قطع' : 'وصل' }}</b> — {{ relay.cut ? 'سوخت و برقِ خودرو قطع است' : 'سوخت و برقِ خودرو قطع نیست' }}</span>
    </div>

    <div
      v-if="state.imei === imei && state.phase === 'sending'"
      class="pcs-card wait"
    >
      <span class="pcs-spin" />
      <div><b>در حالِ فرستادنِ دستورِ {{ verb }}…</b></div>
    </div>

    <div
      v-else-if="state.imei === imei && state.phase === 'waiting'"
      class="pcs-card wait"
    >
      <span class="pcs-spin" />
      <div>
        <b>دستورِ {{ verb }} به دستگاه رسید</b>
        <small>در انتظارِ تأییدِ دستگاه… {{ faNum(elapsed) }} ثانیه</small>
      </div>
    </div>

    <div
      v-else-if="state.imei === imei && (state.phase === 'result' || state.phase === 'deferred')"
      class="pcs-card"
      :class="state.kind"
    >
      <span class="pcs-ic">{{ icon }}</span>
      <div>
        <b>{{ state.title }}</b>
        <small v-if="state.text">{{ state.text }}</small>
        <code v-if="state.raw">{{ state.raw }}</code>
      </div>
      <button
        v-if="state.phase === 'result'"
        type="button"
        class="pcs-close"
        aria-label="بستن"
        @click="$emit('dismiss')"
      >
        ×
      </button>
    </div>
  </div>
</template>

<script>
import { faNum } from '@/mixins/deviceCommand'

export default {
  name: 'PowerCommandStatus',
  props: {
    imei: { type: String, default: '' },
    state: { type: Object, required: true },
    relay: { type: Object, default: () => ({ known: false, cut: false }) },
    elapsed: { type: Number, default: 0 },
    dark: { type: Boolean, default: false },
    showRelay: { type: Boolean, default: true },
  },
  computed: {
    verb() {
      return this.state.commandType === 'powerOff' ? 'قطع' : 'وصل'
    },
    icon() {
      return {
        ok: '✓', bad: '!', warn: '⏳', timeout: '⏱', wait: '⏳', muted: '–',
      }[this.state.kind] || ''
    },
  },
  methods: { faNum },
}
</script>

<style scoped>
.power-cmd-status { font-family: inherit; text-align: right; }
.pcs-relay {
  margin: 6px 0; border-radius: 10px; padding: 6px 10px; font-size: 0.8rem; border: 1px solid;
}
.pcs-relay.on { background: #eef9f5; border-color: #bfe5d5; color: #1e8f69; }
.pcs-relay.cut { background: #fdf3f2; border-color: #f0cfcb; color: #c0392b; }
.pcs-card {
  position: relative; margin: 8px 0; border-radius: 10px; padding: 9px 12px 9px 28px;
  display: flex; gap: 9px; align-items: flex-start; border: 1px solid; font-size: 0.85rem; line-height: 1.7;
}
.pcs-card b { display: block; font-size: 0.85rem; }
.pcs-card small { display: block; font-size: 0.78rem; opacity: 0.9; }
.pcs-card code {
  display: inline-block; direction: ltr; font-size: 0.7rem; background: rgba(0, 0, 0, 0.06);
  border-radius: 4px; padding: 0 5px; margin-top: 3px; color: inherit;
}
.pcs-ic { font-weight: 800; font-size: 1rem; line-height: 1.5; }
.pcs-card.ok { background: #eef9f5; border-color: #bfe5d5; color: #1e8f69; }
.pcs-card.bad { background: #fdf3f2; border-color: #f0cfcb; color: #c0392b; }
.pcs-card.warn { background: #fdf7ef; border-color: #f0dfc4; color: #b86a14; }
.pcs-card.timeout { background: #f3f1ea; border-color: #e3dcc8; color: #8a6d1d; }
.pcs-card.wait { background: #f2f6fa; border-color: #d3e0ed; color: #3b6ea3; }
.pcs-card.muted { background: #eef0f3; border-color: #dde1e6; color: #6b7785; }
.pcs-close {
  position: absolute; left: 6px; top: 4px; border: 0; background: transparent; color: inherit;
  font-size: 1.1rem; line-height: 1; cursor: pointer; opacity: 0.7;
}
.pcs-spin {
  flex: 0 0 auto; width: 15px; height: 15px; margin-top: 4px; border-radius: 50%;
  border: 2px solid #b9cde2; border-top-color: #3b6ea3; animation: pcs-spin 0.9s linear infinite;
}
@keyframes pcs-spin { to { transform: rotate(360deg); } }

/* داشبوردِ تیرهٔ موبایل */
.dark .pcs-relay.on, .dark .pcs-card.ok { background: rgba(47, 185, 138, 0.16); border-color: rgba(47, 185, 138, 0.45); color: #8fe3c4; }
.dark .pcs-relay.cut, .dark .pcs-card.bad { background: rgba(232, 95, 80, 0.16); border-color: rgba(232, 95, 80, 0.5); color: #ffb3aa; }
.dark .pcs-card.warn { background: rgba(240, 160, 60, 0.15); border-color: rgba(240, 160, 60, 0.45); color: #ffd39a; }
.dark .pcs-card.timeout { background: rgba(220, 200, 140, 0.12); border-color: rgba(220, 200, 140, 0.4); color: #eadba8; }
.dark .pcs-card.wait { background: rgba(120, 170, 230, 0.14); border-color: rgba(120, 170, 230, 0.45); color: #b9d6f7; }
.dark .pcs-card.muted { background: rgba(255, 255, 255, 0.06); border-color: rgba(255, 255, 255, 0.2); color: #c9ced6; }
.dark .pcs-card code { background: rgba(255, 255, 255, 0.1); }
.dark .pcs-spin { border-color: rgba(185, 214, 247, 0.35); border-top-color: #b9d6f7; }
</style>
